import { useState } from "react";
import { UnitRead } from "@types";

export function useManageUnits() {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState<UnitRead | null>(null);

  const handleCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
    setSelectedUnit(null);
  };

  const handleRowClick = (rowData: { data: UnitRead }) => {
    setSelectedUnit(rowData.data);
    setIsDetailsModalOpen(true);
  };

  return {
    handleRowClick,
    selectedUnit,
    isDetailsModalOpen,
    handleCloseDetailsModal,
  };
}
